import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import type { TenantOperationalConfigurationRoot } from '../models/tenant-organization/tenant-operational-configuration.model';
import type { TenantSubscriptionSummaryDto } from '../models/tenant-organization/tenant-subscription.models';

@Injectable({ providedIn: 'root' })
export class TenantOrganizationService {
  private readonly http = inject(HttpClient);

  private apiUrl(path: string): string {
    const base = environment.apiBaseUrl.replace(/\/+$/, '');
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${base}${p}`;
  }

  getOperationalSettings(): Observable<TenantOperationalConfigurationRoot> {
    return this.http.get<TenantOperationalConfigurationRoot>(this.apiUrl('/api/TenantOrganization/OperationalSettings'));
  }

  updateOperationalSettings(body: TenantOperationalConfigurationRoot): Observable<unknown> {
    return this.http.put(this.apiUrl('/api/TenantOrganization/OperationalSettings'), body);
  }

  getSubscription(): Observable<TenantSubscriptionSummaryDto> {
    return this.http.get<TenantSubscriptionSummaryDto>(this.apiUrl('/api/TenantOrganization/Subscription'));
  }
}
